export default {
  SET_RATE_PLANS (state, rate_plans) {
    state.rate_plans = rate_plans
  },
  REMOVE_RECORD (state, itemId) {
    const ratePlanIndex = state.rate_plans.findIndex((u) => u.id === itemId)
    state.rate_plans.splice(ratePlanIndex, 1)
  }
}
